import { IGuessWordCards, SearchWord } from 'shared/models';

export const formatSearchWords = (input: IGuessWordCards) => {
  const result: Record<number, SearchWord[]> = {};

  input.forEach(({ words, pos }) => {
    result[pos] = words;
  });

  return {
    posList: Object.keys(result),
    wordsMap: result,
  };
};
